import React from 'react'
import PropTypes from 'prop-types'
import { Paper, Typography } from '@material-ui/core'
import { Block } from '@material-ui/icons'
import {
  Container,
  Content,
  Head,
  Body,
} from './styles'

export default function ErrorCard(props) {
  const {
    title,
    children,
    message,
  } = props

  return (
    <Container>
      <Paper>
        <Content>
          <Head>
            <Block color="secondary" />
            <Typography variant="h5">
              { title }
            </Typography>
          </Head>
          <Body>
            <Typography variant="h6">
              { message }
            </Typography>
            { children }
          </Body>
        </Content>
      </Paper>
    </Container>
  )
}

ErrorCard.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
}

ErrorCard.defaultProps = {
  title: 'Houve um erro!',
  message: '',
  children: null,
}
